// extracted by mini-css-extract-plugin
module.exports = {"confirmation-popup":"_1hbSlRm","confirmationPopup":"_1hbSlRm","showPopup":"_15lkhDM"};